/**
 * FutureBot static page registry.
 *
 * Maps route patterns to a pageId + title so the widget always knows what
 * screen the user is on, even on pages that haven't registered live agent
 * tools. Rich page descriptions/knowledge live server-side keyed by pageId
 * (functions/FutureBot/knowledge/) — keep pageIds in sync with that.
 *
 * Pages that need hands-on tools (like the campaign builder) additionally
 * register themselves at runtime via useAgentPage(); a live registration
 * always wins over this static map.
 */

import { matchPath } from 'react-router-dom';

// Order matters: first match wins, so keep more specific patterns first.
const STATIC_PAGES = [
  { pageId: 'crm-campaign-builder', routes: ['/crm/campaigns/builder/:templateId', '/crm/campaigns/builder'], title: 'Campaign Builder' },
  { pageId: 'crm-campaign-view', routes: ['/crm/campaigns/view/:templateId'], title: 'Campaign View' },
  { pageId: 'crm-campaign-analytics', routes: ['/crm/campaigns/analytics'], title: 'Campaign Analytics' },
  { pageId: 'crm-campaigns', routes: ['/crm/campaigns'], title: 'Campaigns Hub' },
  { pageId: 'crm-my-marketing', routes: ['/crm/my-marketing/newsletters/:newsletterId', '/crm/my-marketing'], title: 'My Marketing' },
  { pageId: 'crm-my-deals', routes: ['/crm/my-deals'], title: 'My Deals' },
  { pageId: 'crm-deal-page', routes: ['/crm/deals/:dealId'], title: 'Deal Page' },
  { pageId: 'crm-person-workspace', routes: ['/crm/workspace/:contactId'], title: 'Person Workspace' },
  { pageId: 'crm-workspace-search', routes: ['/crm/workspace'], title: 'Workspace Search' },
  { pageId: 'crm-calendar', routes: ['/crm/calendar'], title: 'CRM Calendar' },
  { pageId: 'crm-analytics', routes: ['/crm/analytics'], title: 'CRM Analytics' },
  { pageId: 'crm-settings', routes: ['/crm/settings'], title: 'CRM Settings' },
  { pageId: 'crm-next-lead-up', routes: ['/crm/next-lead-up'], title: 'Next Lead Up' },
  { pageId: 'crm-mortgage-monitor', routes: ['/crm/mortgage-monitor'], title: 'Mortgage Monitor' },
  { pageId: 'crm-leaderboard', routes: ['/crm/leaderboard'], title: 'Leaderboard' },
  { pageId: 'crm-signature-studio', routes: ['/crm/signature-studio'], title: 'Signature Studio' },
  { pageId: 'crm-admin', routes: ['/crm/admin'], title: 'CRM Admin' },
  { pageId: 'crm-ideas', routes: ['/crm/ideas'], title: 'CRM Ideas' },
  { pageId: 'crm-dashboard', routes: ['/crm/contacts/:contactId', '/crm/dashboard', '/crm'], title: 'Origin Dashboard' },
  { pageId: 'homepage', routes: ['/'], title: 'Hub Homepage' },
];

/**
 * Resolve the static page entry for a pathname.
 * Returns { pageId, title } or a generic fallback (never null).
 */
export function matchCurrentPage(pathname) {
  for (const page of STATIC_PAGES) {
    for (const route of page.routes) {
      if (matchPath(pathname, { path: route, exact: true })) {
        return { pageId: page.pageId, title: page.title };
      }
    }
  }
  if (pathname.startsWith('/crm')) {
    return { pageId: 'crm-page', title: 'Origin CRM' };
  }
  return { pageId: 'hub-page', title: 'Future Operations Hub' };
}

export default STATIC_PAGES;
